import * as React from "react";
import {
  List, Datagrid, TextField, Show, SimpleShowLayout, TextInput, SearchInput,
} from "react-admin";
import { JsonField } from "../../components/JsonField";
import { TechInfo } from "../../components/ui";

const filters = [
  <SearchInput key="q" source="q" alwaysOn />,
  <TextInput key="category" source="category" label="Catégorie" />,
];

// ExerciseController : lecture seule (GET /exercises?category=,
// GET /exercises/{id}). Pas de création / édition / suppression côté API —
// les exercices des pros se gèrent via « pro-exercises ».
export default {
  list: () => (
    <List filters={filters}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="title" />
        <TextField source="category" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show actions={false}>
      <SimpleShowLayout>
        <TextField source="title" />
        <TextField source="description" />
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
